import Event from './Event';
import LocalStorage from '../local_data';

class GetUserData extends Event {
    eventName = 'oms_getUserData';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for get user data
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        if (clientId) {
            let userData = new LocalStorage.UserData(clientId).getData();

            this.onSuccessEvent({
                data: userData
            }, {
                'action' : action, 
                'request_id' : requestId 
            });
        }
        else {
            //fire error event
            this.onErrorEvent({ "message": "client_id is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default GetUserData;